<button aria-label="Example icon button with a vertical three dot icon" mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon class="td-dots-icon">more_horiz</mat-icon>
</button>

<mat-menu #lib_word_1="matMenu">
  <button mat-menu-item (click)="onOpenWordDialog()">
    <mat-icon>open_in_browser</mat-icon>
    Open
  </button>
  @if (isMine) {
    <button mat-menu-item (click)="onOpenWordEditDialog()">
      <mat-icon>edit</mat-icon>
      Edit
    </button>
    <button class="delete-button" mat-menu-item (click)="onOpenWordDeleteDialog()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  }
</mat-menu>

<mat-menu #lib_pair_1="matMenu">
  <button mat-menu-item (click)="onOpenPairDialog()">
    <mat-icon>open_in_browser</mat-icon>
    Open
  </button>
  @if (isMine) {
    <button mat-menu-item (click)="onOpenPairEditDialog()">
      <mat-icon>edit</mat-icon>
      Edit
    </button>
    <button class="delete-button" mat-menu-item (click)="onOpenPairDeleteDialog()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  }
</mat-menu>

<mat-menu #lib_dic_1="matMenu">
  <button mat-menu-item (click)="onOpenDic()">
    <mat-icon>open_in_new</mat-icon>
    Open
  </button>
  @if (isMine) {
    <button class="delete-button" mat-menu-item (click)="onOpenDicDeleteDialog()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  }
</mat-menu>
